import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbLayoutModule, NbSidebarModule, NbMenuModule, NbUserModule, NbActionsModule, NbSearchModule, NbContextMenuModule, NbTabsetModule, NbCardModule, NbListModule, NbIconModule, NbButtonModule, NbInputModule, NbFormFieldModule, NbToggleModule, NbAccordionModule, NbTreeGridModule, NbDialogModule, NbWindowModule, NbToastrModule, NbStepperModule, NbSelectModule, NbCheckboxModule, NbSpinnerModule, NbDatepickerModule, NbTooltipModule } from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { TranslateModule } from '@ngx-translate/core';
import { GalleryModule } from 'ng-gallery';
import { Ng5SliderModule } from 'ng5-slider';

import { SideSearchComponent } from './side-search/side-search.component';
import { HomeSearchComponent } from './home-search/home-search.component';
import { PopertyCardComponent } from './poperty-card/poperty-card.component';
import { TopHeaderComponent } from './top-header/top-header.component';
import { CcaComponent } from './cca/cca.component';
import { CatsComponent } from './cats/cats.component';
import { AgentComponent } from './agent/agent.component';
import { PartenairesComponent } from './partenaires/partenaires.component';
import { CallComponent } from './call/call.component';
import { PropertyCardListComponent } from './property-card-list/property-card-list.component';
import { HeadSinglePropertyComponent } from './head-single-property/head-single-property.component';
import { VehiculeComponent } from './vehicule/vehicule.component';
import { FormDossierComponent } from './form-dossier/form-dossier.component';
import { PreloaderComponent } from './preloader/preloader.component';
import { FrameplayerComponent } from './frameplayer/frameplayer.component';
import { SlideBienComponent } from './slide-bien/slide-bien.component';
import { PlayerComponent } from './player/player.component';
import { StatsComponent } from './stats/stats.component';

@NgModule({
  declarations: [
    SideSearchComponent,
    HomeSearchComponent,
    PopertyCardComponent,
    TopHeaderComponent,
    CcaComponent,
    CatsComponent,
    AgentComponent,
    PartenairesComponent,
    CallComponent,
    PropertyCardListComponent,
    HeadSinglePropertyComponent,
    VehiculeComponent,
    FormDossierComponent,
    PreloaderComponent,
    FrameplayerComponent,
    SlideBienComponent,
    PlayerComponent,
    StatsComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NbLayoutModule,
    NbSidebarModule,
    NbMenuModule,
    NbUserModule,
    NbActionsModule,
    NbSearchModule,
    NbContextMenuModule,
    NbTabsetModule,
    NbCardModule,
    NbListModule,
    NbIconModule,
    NbButtonModule,
    NbInputModule,
    NbFormFieldModule,
    NbToggleModule,
    NbAccordionModule,
    NbTreeGridModule,
    NbDialogModule,
    NbWindowModule,
    NbToastrModule,
    NbStepperModule,
    NbSelectModule,
    NbCheckboxModule,
    NbSpinnerModule,
    NbDatepickerModule,
    NbTooltipModule,
    NbEvaIconsModule,
    TranslateModule,
    GalleryModule,
    Ng5SliderModule
  ],
  exports: [
    SideSearchComponent,
    HomeSearchComponent,
    PopertyCardComponent,
    TopHeaderComponent,
    CcaComponent,
    CatsComponent,
    AgentComponent,
    PartenairesComponent,
    CallComponent,
    PropertyCardListComponent,
    HeadSinglePropertyComponent,
    VehiculeComponent,
    FormDossierComponent,
    PreloaderComponent,
    FrameplayerComponent,
    SlideBienComponent,
    PlayerComponent,
    StatsComponent,
    TranslateModule,
    GalleryModule,
    Ng5SliderModule,
    NbLayoutModule,
    NbSidebarModule,
    NbMenuModule,
    NbUserModule,
    NbActionsModule,
    NbSearchModule,
    NbContextMenuModule,
    NbTabsetModule,
    NbCardModule,
    NbListModule,
    NbIconModule,
    NbButtonModule,
    NbInputModule,
    NbFormFieldModule,
    NbToggleModule,
    NbAccordionModule,
    NbTreeGridModule,
    NbDialogModule,
    NbWindowModule,
    NbToastrModule,
    NbStepperModule,
    NbSelectModule,
    NbCheckboxModule,
    NbSpinnerModule,
    NbDatepickerModule,
    NbTooltipModule,
    NbEvaIconsModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LayoutsModule { } 